import { getCurrentAuthenticatedUser } from './get-current-authenticated-user'

export const getCurrentUserEmail = async (): Promise<string | undefined> => {
  const cognitoUser = await getCurrentAuthenticatedUser()
  if (!cognitoUser) {
    return
  }
  return cognitoUser.attributes.email
}
